import { profileInstance } from "hooks/useRequest/helper";
import * as ApiUrl from "api/routes";
import TokenService from "services/token.service"


export const getProject = async ({ id }) => {
    return await profileInstance.get(ApiUrl.PROJECTS_URL + "/" + id, {
        headers: {
            authorization: `Token ${TokenService.getLocalAccessToken()}`
        }
    })
        .then(res => res.data)
};

export const getProjects = async (params) => {
    return await profileInstance.get(ApiUrl.PROJECTS_URL + "/all-projects", {
        ...params,
        headers: {
            authorization: `Token ${TokenService.getLocalAccessToken()}`
        }
    })
        .then(res => res.data)
};